import { render, staticRenderFns } from "./LimbicMap.vue?vue&type=template&id=601b4458&scoped=true&"
import script from "./LimbicMap.vue?vue&type=script&lang=js&"
export * from "./LimbicMap.vue?vue&type=script&lang=js&"
import style0 from "./LimbicMap.vue?vue&type=style&index=0&id=601b4458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b4458",
  null
  
)

export default component.exports